export const validateMediaBudgetInput = (
    inputValue: number | null | undefined,
): number | null => {
    if (inputValue === null || inputValue === undefined) {
        return null;
    }

    if (inputValue < 0) {
        return 0;
    }

    return inputValue;
};
